class TMv_LO_HorizontalPhotoSlider {

	items = [];
	timer_id;
	speed;
	container;
	showing = 1;
	num_images = 0;

	constructor(element, options)
	{
		this.element = element;
		this.timer_ms = options.timer_ms;
		this.speed = options.speed;

		// Track window resizing to enforce height
		window.addEventListener('resize',this.resizedWindow.bind(this) );

		this.container = this.element.querySelector('.slider_image_container');
		this.num_images = this.container.childElementCount;
	

		// Add the active state to the first one
		this.element.querySelectorAll('.item_1').forEach(el => el.classList.add('active'));


		// Start the scrolling after 2 seconds
		setTimeout(() =>
		{
			this.showNext();
		},2000);
	}

	showNext()
	{
		// turn off the left position of the
		this.container.style.transition = 'left '+this.speed+'ms';
		this.container.style.left = '-75%';

		// Remove all the active states
		this.element.querySelectorAll('.active').forEach(el => el.classList.remove('active'));

		// Increase and roll over
		this.showing += 1;
		if(this.showing > this.num_images)
		{
			this.showing = 1;
		}

		// Add the active state
		this.element.querySelectorAll('.item_' + this.showing).forEach(el => el.classList.add('active'));


		clearTimeout(this.timer_id);
		this.timer_id = setTimeout(() =>
		{
			// turn off the left position of the
			this.container.style.transition = null;
			this.container.style.left = null;//'0';

			// Take the first one and move it to the back of the line,
			let first_image = this.element.querySelector('img');
			this.container.append(first_image);

			setTimeout(() => {
				this.showNext();
			},this.timer_ms/2);


		}, this.timer_ms/2);
	}

	resizedWindow()
	{
		let first_image = this.element.querySelector('img');

		let container = this.element.querySelector('.slider_image_container');
		container.style.height = first_image.height + 'px';
	}
}
